//------------- COMPONENT LOGIN ---------

//formulário de login da página Login

//importações
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./styles.css";
import { FiEyeOff, FiEye } from "react-icons/fi";
//env
import Requests from "../../services/requests";

//components
import toast, { Toaster } from "react-hot-toast";
import RoundedButton from "../btn-rounded";

//component
const LoginComponent = ({ token, setToken }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [contador, setContador] = useState(0);
    const [passwordType, setPasswordType] = useState("password");
    const [isVisible, setIsVisible] = useState(false);

    //gerencia o envio do form de login
    const handleSubmit = (e) => {
        console.clear();
        e.preventDefault();
        const obj = {
            params: {
                email: email,
                senha: senha,
            },
        };
        //envia a request de login com o usuário inserido
        Requests.login(obj)
            .then((res) => {
                if (res) {
                    if (res.invalido) {
                        toast.error(res.mensagem);
                    } else {
                        if (res.id) {
                            toast.success("Login efetivado!");
                            setTimeout(() => {
                                console.clear();
                                //setta o token da sessão retornado pela request e o usuário
                                setToken(res.token);
                                sessionStorage.setItem("token", JSON.stringify(res.token));
                                sessionStorage.setItem("user", JSON.stringify(res));
                                //redireciona para a pagina Home
                                let path = "/home";
                                navigate(path);
                            }, 750);
                        }
                    }
                }
            })
            .catch((res, err) => {
                console.log(res, err);
            });
    };

    useEffect(() => {
        if (contador > 0) {
            setTimeout(() => {setContador(contador-1)}, 1000)
        }
    }, [contador])

    //gerencia o click no "redefinir senha"
    const handleForgotPass = () => {
        setContador(60);
        if (email) {
            const obj = {
                params: {
                    email: email,
                },
            };
            //envia a request de solicitação de nova senha
            Requests.forgotPass(obj)
                .then((res) => {
                    if (res) {
                        if (res.invalido) {
                            toast.error(res.mensagem);
                        } else {
                            toast.success("Uma nova senha foi enviada para seu email!");
                        }
                    }
                })
                .catch((res, err) => {
                    console.log(res, err);
                });
        } else {
            toast("Insira seu email no campo 'Email' e clique novamente em 'redefinir senha'");
        }
    };

    useEffect(() => {
        isVisible ? setPasswordType("text") : setPasswordType("password")
    }, [isVisible])

    //view do component
    return (
        <div className="login-div-box">
            <div>
                <Toaster />
            </div>
            <form className="login-form-box" onSubmit={handleSubmit}>
                <p className="login-logo-inspe">iNspe</p>
                <p className="login-submsg">Bem-vindo!</p>
                <p className="login-title">Login</p>
                <div className="login-form">
                    <label className="login-lbl-inpt">
                        Email
                        <input
                            className="inpt-text"
                            type="email"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2, 4}$"
                            placeholder="email@email.com"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                        />
                    </label>
                    <label className="login-lbl-inpt">
                        Senha
                        <div className="inpt-pass div-pass">
                            <input 
                                style={{flex: 1}}
                                type={passwordType}
                                placeholder="Senha"
                                value={senha}
                                onChange={(e) => {
                                    setSenha(e.target.value);
                                }}
                            />
                            <div onClick={() => setIsVisible(!isVisible)}>
                                {isVisible ? <FiEyeOff  /> : <FiEye />}
                            </div>
                        </div>
                    </label>
                    <div className="login-div-buttons">
                        <RoundedButton type="submit" text="Entrar" />
                        {contador === 0 && 
                            <p className="login-btn" onClick={handleForgotPass}>
                                Esqueci minha senha
                            </p>
                        }
                        {contador > 0 && 
                            <p style={{fontSize: 14}}>
                                Não recebeu email? Tente novamente em {contador}s. 
                            </p>
                        }
                    </div>
                </div>
            </form>
        </div>
    );
};

export default LoginComponent;
